import { type FC } from 'react'

import { Rating } from 'base-ui'

import { TosSuperscriptHowProductRatingCalculated } from '../../../tos-superscripts'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemReview: FC = () => {
  const { algoliaRecord: item } = useProductSearchResultItemContext()

  if (item.ratingCount < 1) {
    return null
  }

  const ratingCountText = `(${item.ratingCount})`

  return (
    <div className="flex items-center gap-1" data-qa-id="ratings-section">
      <div>
        <Rating className="text-2xl" readOnly value={item.averageRating} />
        <TosSuperscriptHowProductRatingCalculated className="align-text-top text-dark-primary-strong" />
      </div>
      <span className="text-xs" data-qa-id="review-count">
        {ratingCountText}
      </span>
    </div>
  )
}
